"use client";

import { useEffect } from "react";
import CloseIcon from "components/icons-svg/CloseIcon";
import MessageIcon from "components/icons-svg/MessageIcon";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { markUI, selectHeaderAlert } from "stores/ui/uiSlice";
const HeaderAlert = () => {
  const dispatch = useAppDispatch();
  const headerAlert = useAppSelector(selectHeaderAlert);
  useEffect(() => {
    if (headerAlert.headerAlertShow && headerAlert.headerAlertMessage) {
      // Set a timeout to dispatch an action to hide the error message after 3 second
      setTimeout(() => {
        dispatch(markUI({
          headerAlert: {
            headerAlertShow: false,
            headerAlertMessage: ""
          }
        }));
      }, 3000); // 3 seconds
    }
  }, [dispatch, headerAlert.headerAlertMessage, headerAlert.headerAlertShow]);
  return headerAlert.headerAlertShow && headerAlert.headerAlertMessage ? <div className='sticky top-0 z-[1400] flex w-full  items-center justify-center bg-[#e4fcf9] py-2.5 pl-5 pr-0 text-black-900 md:px-5' data-sentry-component="HeaderAlert" data-sentry-source-file="HeaderAlert.tsx">
      <MessageIcon data-sentry-element="MessageIcon" data-sentry-source-file="HeaderAlert.tsx" />
      &nbsp;&nbsp;
      <p className='text-sm'>{headerAlert.headerAlertMessage}</p>
      <button aria-label='close-icon' className='btn btn-ghost static right-0 ml-2.5 h-auto w-auto min-w-[auto] p-2 hover:bg-gray-50 md:absolute md:right-2.5' type='button' onClick={() => {
      dispatch(markUI({
        headerAlert: {
          headerAlertShow: false,
          headerAlertMessage: ""
        }
      }));
    }}>
        <CloseIcon className='h-5 w-5 text-[#0695A1]' data-sentry-element="CloseIcon" data-sentry-source-file="HeaderAlert.tsx" />
      </button>
    </div> : null;
};
export default HeaderAlert;